"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The names of the string constants you can use as HTML attributes for the <tableau-ask-data> web component.
 * @ignore
 */
var AskDataAttributes;
(function (AskDataAttributes) {
    AskDataAttributes["Origin"] = "origin";
    AskDataAttributes["ShowEmbed"] = "showEmbed";
    AskDataAttributes["ShowPin"] = "showPin";
    AskDataAttributes["ShowSave"] = "showSave";
    AskDataAttributes["ShowShare"] = "showShare";
})(AskDataAttributes = exports.AskDataAttributes || (exports.AskDataAttributes = {}));
//# sourceMappingURL=AskDataInterfaces.js.map